import * as yup from 'yup';

export const validationSchema = [
  yup.object().shape({
    basicInformation: yup.object().shape({
      title: yup.string().required('Title of the Campaign is required'),
      description: yup.string().required('Description of the Campaign is required'),
      adType: yup.string().required('Please select type of the campaign'),
    })
  }),
  yup.object().shape({
    content: yup.object().shape({
      campaignType: yup.string(),
      redirectLink: yup.string().matches(
        /^(?:http(s)?:\/\/)?(www.)?(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/,
        'Enter valid url'
      )
        .required('Please enter redirect link'),
      mediaFile: yup.mixed().when('campaignType', {
        is: (val) => val !== 'V' && val !== 'B',
        then: yup.mixed().required('Imagee is required'),
        otherwise: yup.mixed().notRequired(),
      }),
      desktopFile: yup.mixed().when('campaignType', {
        is: (val) => val === 'B',
        then: yup.mixed().required('Desktop image is required'),
        otherwise: yup.mixed().notRequired(),
      }),
      mobileFile: yup.mixed().when('campaignType', {
        is: (val) => val === 'B',
        then: yup.mixed().required('Mobile image is required'),
        otherwise: yup.mixed().notRequired(),
      }),
      poll: yup.object().when('campaignType', {
        is: (val) => val === 'poll',
        then: yup.object().shape({
          question: yup.string().required('Poll question is required'),
          choices: yup.array().min(2, 'At least two choices are required').required('Poll choices are required'),
          postVotingMessage: yup.string().required('Post voting message is required')
        }),
        otherwise: null,
      }),
    })
  }),
  yup.object().shape({
    location: yup.object().shape({})
  }),
  yup.object().shape({
    products: yup.object().shape({
      sections: yup.array().required('At least one Product is required').min(1, 'At least one Product is required'),
    })
  }),
  yup.object().shape({
    duration: yup.object().shape({
      startDate: yup.date().min(new Date(Date.now() - 86400000), "Date cannot be in the past").required('Start date is required'),
      scheduleEndDate: yup.date().when('startDate', (startDate: Date, schema: any) => startDate && schema.min(startDate, 'End date have to be greater than Start date')).default(null).nullable(),
    })
  }),
]